import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import RequireAuth from "../components/RequireAuth";

const API_BASE = "https://eluvent.com/api";

const VisualProjectsContent = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    axios.get(`${API_BASE}/visual/projects`, { withCredentials: true })
      .then(res => setProjects(res.data.projects || []))
      .catch(() => setError("Could not load your projects."))
      .finally(() => setLoading(false));
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this project?")) return;
    try {
      await axios.delete(`${API_BASE}/visual/projects/${id}`, { withCredentials: true });
      setProjects(prev => prev.filter(p => p.id !== id));
    } catch {
      alert("Delete failed.");
    }
  };

  if (loading) {
    return <div style={{ textAlign: "center", padding: 40, fontFamily: "'Nunito', sans-serif" }}>Loading…</div>;
  }

  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: 20, fontFamily: "'Nunito', sans-serif" }}>
      <Link to="/visual-lab" style={{ color: "#6366f1", fontWeight: 700, fontSize: 13 }}>
        ← Back to Visual Lab
      </Link>

      <h1 style={{ textAlign: "center", color: "#1e3a5f", margin: "16px 0" }}>📁 My Visual Projects</h1>

      {error && <p style={{ textAlign: "center", color: "#ef4444" }}>{error}</p>}

      {!error && projects.length === 0 && (
        <p style={{ textAlign: "center", color: "#64748b" }}>
          No projects yet. Create one from the Visual Lab.
        </p>
      )}

      <div style={{ display: "grid", gap: 12 }}>
        {projects.map(project => (
          <div
            key={project.id}
            style={{
              background: "white",
              borderRadius: 16,
              padding: 16,
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              border: "1px solid #e2e8f0",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <div>
              <h3 style={{ margin: 0, fontSize: 18, color: "#1e293b" }}>{project.title}</h3>
              <p style={{ margin: "4px 0 0", fontSize: 12, color: "#64748b" }}>
                {project.project_type} • {new Date(project.updated_at).toLocaleDateString()}
              </p>
            </div>
            <button
              onClick={() => handleDelete(project.id)}
              style={{
                padding: "6px 12px",
                background: "#fee2e2",
                color: "#dc2626",
                border: "none",
                borderRadius: 20,
                fontWeight: 700,
                cursor: "pointer"
              }}
            >
              Delete
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default function VisualProjects() {
  return (
    <RequireAuth>
      <VisualProjectsContent />
    </RequireAuth>
  );
}